import styled, { css } from 'styled-components';

export const InputBoxContainer = styled.div`
  &.in-filter .fa {
    right: 10px;
    top: 50%;
    margin-top: -8px;
    color: #000;
  }
`;

export const CalendarPlace = styled.div`
  position: absolute;
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      .rc-calendar-year-panel,
      .rc-calendar-year-panel-body,
      .rc-calendar-date-panel,
      .rc-calendar-date-panel-body,
      .rc-calendar-time-panel,
      .rc-calendar-time-panel-body,
      .rc-time-picker-panel-inner,
      .rc-calendar-month-panel,
      .rc-calendar-month-panel-body {
        background: #262b31;
        color: #fff;
      }
      .rc-time-picker-panel-select li:hover {
        background: #edfaff;
      }
    `}
`;

export const InputBox = styled.div`
  position: relative;
  i {
    position: absolute;
    top: 2px;
    right: 0px;
    color: #fff;
    opacity: 0.6;
  }
`;
